import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6199d2dc")

_pushScopeId("data-v-6199d2dc")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TrBody = _resolveComponent("TrBody")

  return (_openBlock(), _createBlock("table", {
    class: [$setup.classes, "w-full"]
  }, [
    _renderSlot(_ctx.$slots, "header", {}, () => [
      _createVNode("thead", null, [
        _createVNode("tr", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList($props.headers, (item, index) => {
            return (_openBlock(), _createBlock("th", {
              key: item.value,
              style: {
              width: item.width,
              minWidth: item.width,
              textAlign: item.align,
              fontWeight: index === 0 ? 'bold' : 'normal',
              position: item.position,
              left: item.left,
              background: item.background || '#fff',
              zIndex: item.zIndex,
              borderRight: item.borderRight,
            }
            }, [
              _renderSlot(_ctx.$slots, `header-` + item.value, { item: item }, () => [
                _createTextVNode(_toDisplayString(item.text), 1)
              ], true)
            ], 4))
          }), 128))
        ])
      ])
    ], {}, true),
    _renderSlot(_ctx.$slots, "body", {}, () => [
      ($props.loading)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "loading", {}, () => [
              _createVNode("pre", null, "..." + _toDisplayString($setup.t('loadingText')), 1)
            ], {}, true)
          ]))
        : (_openBlock(), _createBlock("tbody", _hoisted_2, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList($props.data, (item, index) => {
              return (_openBlock(), _createBlock(_component_TrBody, {
                onChangeValue: $setup.handleChangeValue,
                onHiddenChild: $setup.toggleRow,
                dataIndex: index,
                item: item,
                key: item.id,
                headers: $props.headers
              }, null, 8, ["onChangeValue", "onHiddenChild", "dataIndex", "item", "headers"]))
            }), 128)),
            ($props.data.length === 0)
              ? _renderSlot(_ctx.$slots, "no-data", { key: 0 }, () => [
                  _createVNode("tr", null, [
                    _createVNode("td", {
                      colspan: $props.headers.length,
                      class: "text-center"
                    }, _toDisplayString($setup.t('noData')), 9, ["colspan"])
                  ])
                ], {}, true)
              : _createCommentVNode("", true)
          ]))
    ], {}, true)
  ], 2))
})